import { render, staticRenderFns } from "./AddRetailerModal.vue?vue&type=template&id=07d8e73a"
import script from "./AddRetailerModal.vue?vue&type=script&lang=js"
export * from "./AddRetailerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports